import { render, staticRenderFns } from "./XuQiuTongJiJiaoNangZhuZhuangTu.vue?vue&type=template&id=d215b77a&scoped=true&"
import script from "./XuQiuTongJiJiaoNangZhuZhuangTu.vue?vue&type=script&lang=js&"
export * from "./XuQiuTongJiJiaoNangZhuZhuangTu.vue?vue&type=script&lang=js&"
import style0 from "./XuQiuTongJiJiaoNangZhuZhuangTu.vue?vue&type=style&index=0&id=d215b77a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215b77a",
  null
  
)

export default component.exports